import { useMutation } from "@apollo/client";

import {
  TransactionTime,
  UpdateSubscriptionMutation,
  UpdateSubscriptionMutationVariables,
} from "@ctypes";
import { GET_SUBSCRIPTION, TRANSACTIONS, UPDATE_SUBSCRIPTION } from "@graphql";
import { DEFAULT_SIZE } from "@hooks/transfers/useTransactions";

export const useUpdateSubscription = () => {
  return useMutation<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>(
    UPDATE_SUBSCRIPTION,
    {
      refetchQueries: [
        { query: GET_SUBSCRIPTION },
        {
          query: TRANSACTIONS,
          variables: {
            size: DEFAULT_SIZE,
            time: TransactionTime.Past,
          },
        },
      ],
      awaitRefetchQueries: true,
    },
  );
};
